export const YesNoBooleanList = [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
]